<template>
	<div class="meter-water-manage-container">
		<el-card shadow="never" class="search-card">
			<div slot="header" class="card-header">
				<span>查询条件</span>
			</div>
			<div class="flex justify-start">
				<el-form :inline="true" :model="queryParams">
					<el-form-item>
						<el-input v-model="queryParams.carNo" placeholder="必填，请填写车牌号" clearable
							style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.startTime" type="date" placeholder="开始时间"
							value-format="yyyy-MM-dd" style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.endTime" type="date" placeholder="结束时间"
							value-format="yyyy-MM-dd" style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
		</el-card>
	
		<el-card shadow="never" class="table-card">
			<div slot="header" class="card-header">
				<span>缴费记录</span>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column type="index" label="序号" width="50" />
				<el-table-column prop="payOrderNo" label="支付订单号" width="200" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.payOrderNo" style="color: #409EFF;"><i class="el-icon-collection" style="margin-right: 3px;font-size: 16px;"></i>{{row.payOrderNo}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="orderNo" label="停车订单号" width="250" align="center">
					<template slot-scope="{ row }">
						<span>{{row.orderNo}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="carNo" label="车牌号" width="120" align="center" />
				<el-table-column label="车辆类型编码" width="120" align="center">
					<template slot-scope="{ row }">{{ row.carTypeNo || '日钢' }}</template>
				</el-table-column>
				<el-table-column prop="payOrderMoney" label="订单金额" width="200" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.payOrderMoney" style="color: #409EFF;">￥{{row.payOrderMoney}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tempTimeCount" label="临时车停车时长" width="200" align="center" />
				<el-table-column prop="orderTypeNo" label="订单类型" width="200" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.orderTypeNo === '5901'" style="color: #409EFF;">月租车充值</span>
						<span v-if="row.orderTypeNo === '5902'" style="color: #409EFF;">临时车缴费</span>
						<span v-if="row.orderTypeNo === '5903'" style="color: #409EFF;">钱包充值</span>
					</template>
				</el-table-column>
				<el-table-column prop="payedMoney" label="支付金额" width="200" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.payedMoney" style="color: red;">￥{{row.payedMoney}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="payedTime" label="支付完成时间" width="200" align="center" />
				<el-table-column prop="payOrderDesc" label="支付订单描述" width="200" align="center" />
			</el-table>
			<el-pagination :current-page="queryParams.indexId+1" :page-size="queryParams.size" :total="total"
				:page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper"
				@size-change="handleSizeChange" @current-change="handlePageChange"
				class="pagination-container" />
		</el-card>
	</div>
</template>

<script>
	import { randomDecimal, generateSign } from '@/api/common/parkAreaApi'
	import axios from 'axios'

	export default {
		name: 'ParkingOwnerCar',
		data() {
			return {
				loading: false,
				list: [],
				total: 0,
				queryParams: {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge",
					startTime: '',
					endTime: ''
				}
			}
		},
		mounted() {
			this.queryParams.startTime = this.formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
			this.queryParams.endTime = this.formatDateTime(new Date())
			this.loadData()
		},
		methods: {
			async loadData() {
				this.loading = true
				try {
					const rand = await randomDecimal()
					this.queryParams.rand = rand.toString()
					this.$delete(this.queryParams,'sign')
					this.queryParams.sign = await generateSign(this.queryParams)
					const { data } = await axios.post('/Api/Inquire/GetListTmpPayRecords', this.queryParams)
					const res = data
					this.list = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : [])
					if(this.queryParams.indexId === 0){
						this.total = this.list.length
						if(this.list.length >= 20) {
							this.getAllTotal(1)
						}
					}
				} catch (e) {
					console.error('获取时间段订单记录失败', e)
				} finally {
					this.loading = false
				}
			},
			async getAllTotal(index) {
				try {
					const dataParams = JSON.parse(JSON.stringify(this.queryParams))
					dataParams.indexId = index
					const rand = await randomDecimal()
					dataParams.rand = rand.toString()
					this.$delete(dataParams, 'sign')
					dataParams.sign = await generateSign(dataParams)
					const { data } = await axios.post('/Api/Inquire/GetListTmpPayRecords', dataParams)
					const res = data
					if(res.code === 1) {
						this.total += res.data.length;
					}
					if(res.code === 1 && res.data.length >= 20){
						await new Promise(resolve => setTimeout(resolve, 500));
						await this.getAllTotal(index+1)
					}
				} catch (e) {
					console.error('获取时间段订单记录失败', e)
				}
			},
			handleSearch() {
				this.queryParams.indexId = 0;
				this.loadData()
			},
			handleReset() {
				this.queryParams = {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge",
					startTime: this.formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000)),
					endTime: this.formatDateTime(new Date())
				};
				this.loadData()
			},
			handleSizeChange(val) {
				this.queryParams.size = val;
				this.loadData()
			},
			handlePageChange(val) {
				this.queryParams.indexId = val - 1;
				this.loadData()
			},
			formatDateTime(date) {
				const y = date.getFullYear()
				const m = String(date.getMonth() + 1).padStart(2, '0')
				const d = String(date.getDate()).padStart(2, '0')
				const h = String(date.getHours()).padStart(2, '0')
				const min = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
				return `${y}-${m}-${d} ${h}:${min}:${s}`
			}
		}
	}
</script>

<style lang="scss" scoped>
	.meter-water-manage-container {
		padding: 20px;
	
		.tree-container {
			min-height: 450px;
			overflow-y: auto;
			background: #fff;
			padding: 10px;
			border-radius: 4px;
		}
	
		.margin-top {
			margin-top: 20px;
		}
	
		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}
	
		.clearfix:after {
			clear: both;
		}
	}
	.tab-component {
		padding: 0;
	}
	
	.search-card {
		margin-bottom: 16px;
	}
	
	.table-card {
		margin-bottom: 0;
	}
	
	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-container {
		text-align: right;
		margin-top: 16px;
	}
</style>